import React from 'react';
import bannerImage from "../../assets/images/interview_banner.svg";
import scrollIcon from "../../assets/images/scroll-down.png";
import MasterLayout from "../../components/Layout/MasterLayout";
import { Badge, Button, Card, Col, Container, Modal, Image, Row, Form } from "react-bootstrap";
import { Typewriter } from "react-simple-typewriter";
import { scrollTo } from "../../components/AnimateScroll/scrollTo";
import DataTableComponent from '../../components/DataTableComponent/DataTableComponent';

const Interviews = () => {

  // Data table columns & data
  const columns = [
		{
			name: "Title",
			selector: (row) => row.title,
		},
		{
			name: "Year",
			selector: (row) => row.year,
		},
	];

	const data = [
		{
			id: 1,
			title: "Beetlejuice",
			year: "1988",
		},
		{
			id: 2,
			title: "Ghostbusters",
			year: "1984",
		},
	];
  // Data table columns & data

  /******************* 
  @Purpose : Used to handle scroll
  @Parameter :()
  @Author : INIC
  ******************/
  const handleScroll = () => {
    document.getElementById("uploadBtn");
    scrollTo({ id: "interviewTable" });
  };

  return (
		<>
			<MasterLayout>
				{/* Start: Hero/Banner Image */}
				<section className="home-banner-wrap">
					<Container>
						<Row>
							<Col sm={6} className="my-auto">
								<h5 className="banner-sub-caption">
									Welcome to Candidate Portal
								</h5>
								<h1 className="banner-main-caption">
									Check for{" "}
									<strong>
										<Typewriter
											words={["Interviews..."]}
											loop={1}
											typeSpeed={130}
											deleteSpeed={50}
											delaySpeed={1000}
										/>
									</strong>
								</h1>
								<Button
									variant="primary"
									id="uploadBtn"
									className="btn-upload"
									onClick={() => handleScroll()}
								>
									Check here <span className="bx bxs-chevron-down"></span>
								</Button>
							</Col>
							<Col sm={6}>
								<div className="banner-img">
									<Image src={bannerImage} alt="Upload Image" />
								</div>
							</Col>
						</Row>
					</Container>
				</section>
				{/* Ends: Hero/Banner Image */}

				{/* Start: Mouse Scroll */}
				<div
					id="mouse_scroll"
					className="mouse_arrow"
					onClick={() => handleScroll()}
				>
					<a className="mouse_icon d-flex" title="Scroll Down">
						<Image
							src={scrollIcon}
							alt="Scroll Down Icon"
							className="scroll-icon"
						/>
					</a>
				</div>
				{/* Ends: Mouse Scroll */}

				{/* Start: Interview Data table */}
        <Container>
          <div className="interview-table" id="interviewTable">
            <DataTableComponent
							columns={columns}
							data={data}
            />
          </div>
        </Container>
				{/* Ends: Interview Data table */}
			</MasterLayout>
		</>
	);
}

export default Interviews